<template>
  <q-toolbar-title
    class="col-auto cursor-pointer"
    data-test-id="header-logo"
  >
    <component
      :is="currentSite.logoRoute ? 'internal-or-external-link' : 'div'"
      :href="currentSite.logoRoute"
      class="col"
      @click="handleClick"
    >
      <img
        alt="Logo"
        :src="$isColorDark(headerColor) ? currentSite.lightLogoImageUrl : currentSite.darkLogoImageUrl"
        :class="{
          'title-logo-small': !$q.screen.gt.sm || compact,
          'q-mb-sm': !compact,
          'q-mt-md': !compact && (
            $q.screen.gt.xs ||
            currentSite.consumerConfig.headerType === HEADER_TYPES.DEFAULT ||
            (!currentSite.consumerConfig.showSiteSelectorOnNavigations && !currentCircuit.supportsTranslations)
          ),
          'title-logo': !compact && $q.screen.gt.xs
        }"
        :style="{
          'max-width': $q.screen.lt.sm ? '30vw' : undefined,
          'max-height': $q.screen.lt.sm ? '50px' : undefined,
          'height': $q.screen.lt.sm ? 'auto' : undefined
        }"
      >
    </component>
  </q-toolbar-title>
</template>

<script>
import { HEADER_TYPES } from 'src/models/site/Site'
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'

export default {
  name: 'HeaderLogo',
  components: {
    InternalOrExternalLink
  },
  configuration: ['currentCircuit', 'currentSite'],
  props: {
    backgroundColor: {
      type: String,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    },
    shouldEmitClicks: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    headerColor () {
      return this.backgroundColor || this.currentSite.headerColor
    }
  },
  created () {
    _.extend(this, { HEADER_TYPES })
  },
  methods: {
    handleClick () {
      if (this.shouldEmitClicks) {
        this.$emit('click')
      } else {
        this.currentSite.navigateToLogoRoute(this.$router)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .title-logo {
    height: 65px;
  }
  .title-logo-small {
    height: 45px;
  }
</style>
